import React, {useState} from 'react'
import {Link} from "react-router-dom";
import {ArrowBackIcon} from "~/Components/Icons/Icons";
import ValidationError from "~/Components/Forms/ValidationError";
import {adminHttp} from "~/Admin/services/http";
import ConfirmedButton from "~/Components/ConfirmedButton/ConfirmedButton";
import AdminHostInvitationForm from "./AdminHostInvitationForm";
import {connect} from "react-redux";
import {Redirect} from "react-router-dom";

const AdminInviteHost = ({event, ...props}) => {

    const defaultFields = {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        message: '',
        deadline: null,
    };

    const [form, setForm] = useState(defaultFields);
    const [errors, setErrors] = useState(null);
    const [message, setMessage] = useState('');
    const [done, setDone] = useState(false);

    const handleFormChange = (values) => {
        setForm({...form, ...values});
    };

    const handleChange = (e) => {

        const name = e.target.name;
        const value = e.target.value;

        setForm({...form, [name]: value});
    };

    const handleSubmit = (date) => {

        const res = adminHttp.post('/events/' + event.id + '/hosts', form);

        res.then((res) => {

            setErrors(null);
            setMessage('');
            setDone(true);

        }).catch((err) => {

            const res = err.response;

            setErrors(res.data.errors);
            setMessage(res.data.message);

        });
    };

    if (done) {
        return <Redirect to="/guests/uploads/hosts" />
    }

    return (
        <>
            <Link to="/guests/uploads/hosts" className="btn btn-secondary btn-sm mb-4">
                <ArrowBackIcon classes="d-inline mr-2"/>
                Back
            </Link>

            <h2 className="mb-0">New Host Invitation</h2>

            {message && (
                <div className="alert alert-danger" role="alert">
                    {message}
                </div>
            )}

            <div className="card shadow-sm bg-white mt-4">
                <div className="card-body">
                    <h3>Host Details</h3>

                    <div className="form-row">
                        <div className="form-group col-md-6 required">
                            <label>First Name</label>
                            <input
                                onChange={handleChange}
                                value={form.first_name}
                                name="first_name"
                                type="text"
                                className="form-control"/>

                            <ValidationError errors={errors} name="first_name"/>
                        </div>
                        <div className="form-group col-md-6 required">
                            <label>Last Name</label>
                            <input
                                onChange={handleChange}
                                value={form.last_name}
                                name="last_name"
                                type="text"
                                className="form-control"/>

                            <ValidationError errors={errors} name="last_name"/>
                        </div>
                    </div>
                    <div className="form-group required">
                        <label>Email Address</label>
                        <input
                            onChange={handleChange}
                            value={form.email}
                            name="email"
                            type="text"
                            className="form-control"/>

                        <ValidationError errors={errors} name="email"/>
                    </div>
                    <div className="form-group required">
                        <label>Phone number</label>
                        <input
                            onChange={handleChange}
                            value={form.phone}
                            name="phone"
                            type="text"
                            className="form-control"/>

                        <ValidationError errors={errors} name="phone"/>
                    </div>

                    <div>
                        <p className="text-caption font-weight-normal mb-0">Your user already exists? You can go back to user selection by clicking below</p>
                        <a href="" className="text-caption text-primary">Select an existing user</a>
                    </div>
                </div>
            </div>
            <div className="card shadow-sm bg-white mt-3">
                <div className="card-body">
                    <h3>Host Invitation</h3>
                    <AdminHostInvitationForm values={form} errors={errors} onChange={handleFormChange} />
                </div>
            </div>

            <ConfirmedButton
                confirmText="Are you sure you want to confirm ?"
                onClick={handleSubmit}
                className="btn btn-primary text-cta float-right mt-3">
                Confirm & Send invitation
            </ConfirmedButton>
        </>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminInviteHost);
